const container = "_container_1vw5h_18";
const input = "_input_1vw5h_26";
const ui = "_ui_1vw5h_27";
const styles = {
  container,
  input,
  ui
};
export {
  container,
  styles as default,
  input,
  ui
};
//# sourceMappingURL=Radio.module.css.js.map
